import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import sortableGroup from 'ember-sortable/modifiers/sortable-group';
import sortableItem from 'ember-sortable/modifiers/sortable-item';
import BvInline from 'volta/components/bv-inline';
import BvDndHandle from 'volta/components/bv-dnd/handle';
import BvTag from 'volta/components/bv-tag';
import BvCheckbox from 'volta/components/bv-checkbox';
import BvRadio from 'volta/components/bv-radio';
import BvBtn from 'volta/components/bv-btn';
import { concat } from '@ember/helper';
import not from 'ember-truth-helpers/helpers/not';
import notEq from 'ember-truth-helpers/helpers/not-eq';
import or from 'ember-truth-helpers/helpers/or';
import { fn } from '@ember/helper';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import type { ICollectionSortOption } from 'volta/models/types/collection-view';
export interface CollectionViewSortListSignature {
    Args: {
        options: ICollectionSortOption[];
        sortLimit?: number;
        disabled?: boolean;
        onDirectionChange?: (sort: ICollectionSortOption) => void;
        onSelectionChange?: (sort: ICollectionSortOption, checked: boolean) => void;
        onReorderOptions?: (sortOptions: ICollectionSortOption[]) => void;
    };
    Element: HTMLDivElement;
}
export default class CollectionViewSortListComponent extends Component<CollectionViewSortListSignature> {
    groupName = `CollectionViewSortList_${guidFor(this)}`;
    handleSortEndAction = (sortOptions: ICollectionSortOption[])=>{
        this.args.onReorderOptions?.([
            ...(sortOptions ?? [])
        ]);
    };
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <div
      class='collection-view-sort-list u-animation-fade-in'
      {{sortableGroup groupName=this.groupName onChange=this.handleSortEndAction direction='y'}}
      ...attributes
    >
      {{#each @options key='value' as |option|}}
        {{#let
          (or @disabled (not option.selected))
          (component BvTag text=option.label color=option.color size='sm')
          as |dndDisabled label|
        }}
          <BvInline
            @blockAlign='center'
            @gap='1'
            @wrap={{false}}
            class='u-py-1 u-px-1 u-bg-surface'
            data-test-name={{option.value}}
            {{sortableItem groupName=this.groupName model=option disabled=dndDisabled}}
          >
            <BvDndHandle @disabled={{dndDisabled}} />
            <BvInline
              @blockAlign='center'
              @align='space-between'
              @wrap={{false}}
              @gap='2'
              class='u-flex-grow-1 u-overflow-hidden'
            >
              {{#if (notEq @sortLimit 1)}}
                <BvCheckbox
                  @label={{label}}
                  @checked={{option.selected}}
                  @disabled={{@disabled}}
                  @onChange={{fn (optional @onSelectionChange) option}}
                  @labelClass='u-overflow-hidden'
                  class='u-overflow-hidden'
                />
              {{else}}
                <BvRadio
                  @label={{label}}
                  @checked={{option.selected}}
                  @disabled={{@disabled}}
                  @onChange={{fn (optional @onSelectionChange) option}}
                  @labelClass='u-overflow-hidden'
                  class='u-overflow-hidden'
                />
              {{/if}}
              <BvBtn
                class='u-flex-shrink-0'
                @subtle={{true}}
                @onClick={{fn (optional @onDirectionChange) option}}
                @disabled={{@disabled}}
                @iconLeft={{if option.asc 'arrow-up' 'arrow-down'}}
                @size='sm'
                @testName={{concat 'sort-direction-' option.label}}
              />
            </BvInline>
          </BvInline>
        {{/let}}
      {{/each}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'CollectionView::SortList': typeof CollectionViewSortListComponent;
        'collection-view/sort-list': typeof CollectionViewSortListComponent;
    }
}
